import React, {useState} from 'react';
import {messageBoxSuccess} from '@deviceinsight/ng-ui-components';
import {Button} from '@deviceinsight/ng-ui-basic-components';

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faEye, faCopy} from '@fortawesome/free-solid-svg-icons';

import {Trans} from '@deviceinsight/ng-ui-scale-lib/api';

type Props = {
	apiKey: string;
};

const ApiKeyComponent = ({apiKey}: Props) => {
	const [inputType, setInputType] = useState<'password' | 'text'>('password');

	const showApiKey = () => {
		inputType === 'password' ? setInputType('text') : setInputType('password');
	};

	const copyApiKey = (apiKey: string) => {
		navigator.clipboard.writeText(apiKey);
		messageBoxSuccess(<Trans i18nKey="kisapi.credentials.apiKeyCopied">The key was copied</Trans>);
	};

	return (
		<span>
			<input
				style={{border: 0, width: 300}}
				size={40}
				maxLength={40}
				type={inputType}
				name="password"
				id="id_password"
				data-testid={`apiKey-${apiKey}`}
				placeholder="No key available"
				value={apiKey}
				readOnly></input>
			<Button naked onClick={() => copyApiKey(apiKey)} style={{height: 20, width: 20, paddingLeft: 4}}>
				<FontAwesomeIcon icon={faCopy} size={'lg'} />
			</Button>
			<Button
				naked
				onClick={showApiKey}
				style={{height: 20, width: 20, paddingLeft: 4}}
				data-testid={`showApiKey-${apiKey}`}>
				<FontAwesomeIcon icon={faEye} size={'lg'} />
			</Button>
		</span>
	);
};

export default ApiKeyComponent;
